export default {
      id: "height-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#height-usage",
      toString: function () {
        return this.url;
      }
    }